import { deepOrange, grey } from '@material-ui/core/colors';
import { createMuiTheme, Theme as MUITheme } from '@material-ui/core';
import personalAgreementBg from '../static/images/personal-agreement-bg.png';
import { BrandsEnum } from '../surveyCollector/SurveyCollector';

const mainColor = '#EA5D1A';

const { spacing } = createMuiTheme();

const myOrange = {
  ...deepOrange,
  '500': mainColor,
  '600': mainColor,
  A100: mainColor,
  A200: mainColor,
  A400: mainColor,
  A700: mainColor,
};

const fontFamily = '"SEATBCN", "Helvetica Neue", Helvetica, Arial, sans-serif';

const theme = {
  palette: {
    primary: myOrange,
    secondary: {
      light: grey.A100,
      main: '#DFDAD5',
      dark: grey.A400,
      contrastText: '#ffffff',
    },
    background: {
      default: 'ffffff',
    },
  },
  typography: {
    fontFamily: fontFamily,
    useNextVariants: true,
  },
  screenElement: {
    sidePadding: spacing(3),
    sidePaddingXs: spacing(),
  },
  images: {
    introDefaultImagePath: 'images/seat/introCar.jpg',
    progressImagePath: 'images/seat/car.png',
    logo: 'images/seat/logo.png',
    favicon: 'favicons/seat.png',
  },
  personalAgreement: {
    backgroundImagePath: personalAgreementBg,
    continueButtonColor: '#EA5D1A',
  },
  title: 'SEAT',
  brandCode: BrandsEnum.SEAT,
};

export type Theme = typeof theme & MUITheme;

export default theme;
